const colleges = {
  all_colleges: '🚸 Todos los colegios',
  create: 'Crear Nuevo Colegio',
  active: 'Activo',
  inactive: 'Inactivo',
  detail: 'Detalle',
  migrate_period: 'Migrar periodo',
  disable_college: 'Deshabilitar colegio(s)',
  filters: 'Filtros',
  clean_up: 'Limpiar',
  search: 'Buscar',
  status: 'Estatus',
  country: 'País',
  school_name: 'Nombre del colegio',
  edit: 'Editar',
  general_information: 'Información general',
  creation: 'Creación',
  sale: 'Venta',
  commune: 'Comuna',
  contact: 'Contacto',
  phone: 'Teléfono',
  analytics: '📊 Panel de Estadísticas 🎓  ',
  current_period_of_operation: 'Periodo actual de operación',
  success_edition_msg: 'El colegio se editó con éxito.',
  error_edition_msg: '¡Algo salió mal! Intenta realizar esta misma acción más tarde.',
  students_migrated: 'Los estudiantes han sido migrados',
  massive_load: 'Carga Masiva',
  new_course: 'Crear curso',
  course_saved_success: 'Curso guardado de manera exitosa',
  school_id: 'ID del colegio',
  payment_identifier: 'Tipo de pagador',
  excel_format: 'Formato del Excel',
  see_an_example: 'Ver ejemplo',
  users_have_DNI_label: '¿Los usuarios tienen DNI?',
  users_have_DNI_yes: 'Sí',
  users_have_DNI_no: 'No',
  dissable_old_data_label: '¿Deshabilitar los datos viejos?',
  dissable_old_data_yes: 'Sí',
  dissable_old_data_no: 'No',
  file: 'Archivo',
  file_placeholder: 'Elija un archivo...',
  error_list: 'Lista de errores',
  successful_upload: '¡Carga exitosa!',
  save_as_txt: 'Guardar como txt',
  massive_load_warning: 'Se desactivarán los estudiantes que no estén en el documento.',
};

export default colleges;
